export default "__VITE_PUBLIC_ASSET__31c882e8__"